'use strict';

import { Buildings, isMobile, settingsData, threeJsVariables } from '../../../settings';
import {
    lazyLoadingData
} from '../../../functions';
import {
    getCurrentCameraDistance,
    getOrbitControlsDistanceAndAngle, getOrbitControlsDistanceAndPan,
    rotateToCamera,
} from '../../controls/orbitControls';
import {ViewMode} from "../../../common";
import {bombButtonInitActionHandler} from "../../controls/destroyBuilding";
import {
    CircleGeometry,
    LineBasicMaterial,
    Mesh,
    MeshBasicMaterial,
    ShapeGeometry,
    Vector3,
    BufferGeometry,
    Line,
    Box3,
    Group,
    Vector2
} from 'three';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import {changeLangToCurrent, getCurrentLang} from "../langSwitcher/langSwitcher";
import * as THREE from "three";
import { BmbyMode } from '../../mode/BmbyMode';


let fontLoaded = false;
let fontLoader = null;
let fontRegular = null;
let fontBold = null;

export async function cylinderFloorNumbers() {
    if (settingsData.activeViewMode !== ViewMode.Cylinder)
        return;

    const cylinderFloorSliderGroupName = 'cylinderFloorNumbers';
    const activeBuilding = Buildings.getActiveBuilding();
    if (/*threeJsVariables.scene.getObjectByName(cylinderFloorSliderGroupName) ||*/ activeBuilding?.floors.length === 1)
        return;

    let cylinderFloorSliderGroup = threeJsVariables.scene.getObjectByName(cylinderFloorSliderGroupName);

    if (cylinderFloorSliderGroup /*&& group.children.length*/) {
        threeJsVariables.scene.remove(cylinderFloorSliderGroup);

        function disposeNode(node) {
            if (node instanceof THREE.Mesh) {
                if (node.geometry) {
                    node.geometry.dispose();
                }

                if (node.material) {
                    if (Array.isArray(node.material)) {
                        node.material.forEach(material => {
                            if (material.map)
                                material.map.dispose();
                            material.dispose();
                        });
                    } else {
                        if (node.material.map)
                            node.material.map.dispose();
                        node.material.dispose();
                    }
                }
            }
        }

        function disposeHierarchy(node, callback) {
            for (let i = node.children.length - 1; i >= 0; i--) {
                let child = node.children[i];
                disposeHierarchy(child, callback);
                callback(child);
            }
        }

        disposeHierarchy(cylinderFloorSliderGroup, disposeNode);
    }

    cylinderFloorSliderGroup = new Group();
    cylinderFloorSliderGroup.name = cylinderFloorSliderGroupName;

    if (!fontLoaded) {
        fontLoader = new FontLoader();
        fontRegular = await lazyLoadingData(fontLoader, 'fonts/assistant/Assistant_Regular.json');
        fontBold = await lazyLoadingData(fontLoader, 'fonts/assistant/Assistant_Bold.json');
        fontLoader = true;
    }

    // const allFonts = await lazyLoadingAll([fontRegular, fontBold]);


    const sortedFloorSelections = activeBuilding.selections.sort((a, b) => a.floor - b.floor);
    const edgeNumbers = [sortedFloorSelections[0].floor, sortedFloorSelections[sortedFloorSelections.length - 1].floor];
    const totalFloors = activeBuilding.selections.length;
    const selectionBoxes = activeBuilding.selectionsGroup;
    selectionBoxes.children.forEach((box) => {
        switch (box.name.charAt(0)) {
            case 'F': {
                const floorNumber = parseInt(box.name.split('_')[1], 10);
                const edgeFloor = edgeNumbers.includes(floorNumber);
                const cylinderFloorElements = createFloorNumber(box, fontRegular, fontBold, floorNumber, selectionBoxes, edgeFloor, totalFloors);
                cylinderFloorSliderGroup.add(cylinderFloorElements);
                break;
            }
            case 'R':
                break;
            case 'L':
                break;
            case 'S':
                break;
        }
    });

    const scene = threeJsVariables.scene;
    scene.add(cylinderFloorSliderGroup);
    threeJsVariables.renderList.reorder();
    showOrHideCylinderFloorNumbers();
    rotateCylinderFloorNumbers();
}

function createFloorNumber(...options) {
    const [box, fontRegular, fontBold, floorNumber, selectionBoxes, edgeFloor, totalFloors] = options;
    const floorNumbersSize = config.threejs.floorNumbers.size;
    const multiple = getMultiple();

    const positionLeftOfBuilding = - 1;
    const baseElementsPosition = floorNumbersSize;
    let color = 0xffffff;

    (config?.resources?.background?.cylinderBg === 'sky') && (color = 0x000000);

    const parent = box.parent.name.split('_');

    const floorCenterSel = selectionBoxes.getWorldPosition(new Vector3());
    const boxSize = new Box3().setFromObject(box).getSize(new Vector3());
    const boxCenter = new Box3().setFromObject(box).getCenter(new Vector3());

    const apartments = box.children.filter(apt => !apt.name.startsWith(config.resources.bundle.selectionBoxes.floorPlugName) && !apt.name.startsWith(`${parent[0]}_amenity`));

    const apartmentsGroup = new Group();
    apartmentsGroup.position.set(box.position.x,box.position.y,box.position.z);

    for (let i = 0; i < apartments.length; i++){
        const cloneApt = apartments[i].clone();
        apartmentsGroup.add(cloneApt);
    }

    const apartmentsGroupBoxSize = new Box3().setFromObject(apartmentsGroup).getSize(new Vector3());
    const apartmentsGroupBoxCenter = new Box3().setFromObject(apartmentsGroup).getCenter(new Vector3());

    let minHeightApt = null;
    let floorBox, floorCenter;

    apartments.forEach((apt) =>{
        const aptBox = new Box3().setFromObject(apt);
        const size = aptBox.getSize(new Vector3());
        if (Math.floor(size.y) !== Math.floor(apartmentsGroupBoxSize.y)){
            minHeightApt = apt;
        }
    });

    if (!minHeightApt){
        floorBox = new Box3().setFromObject(apartments[0]);
        floorCenter = floorBox.getCenter(new Vector3());
    } else {
        floorBox = new Box3().setFromObject(minHeightApt);
        floorCenter = floorBox.getCenter(new Vector3());

        apartmentsGroupBoxCenter.y = apartmentsGroupBoxCenter.y + selectionBoxes.position.y;

        if (floorCenter.y < apartmentsGroupBoxCenter.y){
            floorCenter = new Vector3(floorCenter.x,apartmentsGroupBoxCenter.y,floorCenter.z);
        }

    }

    const floorElements = new Group();
    floorElements.name = 'floorElements';
    floorElements.position.set(floorCenterSel.x, floorCenter.y, floorCenterSel.z);
    floorElements.userData.floorIndex = floorNumber;
    floorElements.userData.floor = floorNumber;

    const floorNumberBool = (!(floorNumber % multiple) || edgeFloor) && totalFloors >= 10;
    const size = (floorNumberBool) ? 1.3 : 1;
    const font = (floorNumberBool) ? fontBold : fontRegular;

    const isBuildingOpacity = Boolean(config.features.buildingOpacity);

    const isGroundFloor = settingsData.groundFloor.isActive && (parseInt(settingsData.groundFloor.floor) === parseInt(floorNumber));
    const shortLabel = settingsData.groundFloor.shortLabel;
    // const shapes = font.generateShapes(`${floorNumber}`, size);
    const shapes = font.generateShapes(`${isGroundFloor ? changeLangToCurrent(shortLabel) : floorNumber}`, size);

    const geometry = new ShapeGeometry(shapes);
    const material = new MeshBasicMaterial({color, transparent: isBuildingOpacity});
    const number = new Mesh(geometry, material);
    Boolean(config.features.buildingOpacity) && number.layers.enable(1);

    const textPositionCorrection = (floorNumber < multiple && floorNumber > 0) ? size * 0.5 : 0;
    const positionNotBoldCorrection = (!floorNumberBool) ? size : 0;
    number.position.set(0, 0.5, (baseElementsPosition - textPositionCorrection - positionNotBoldCorrection) * positionLeftOfBuilding );
    number.userData.defaultPosition = new Vector3(0, 0.5, (baseElementsPosition - textPositionCorrection - positionNotBoldCorrection) * positionLeftOfBuilding);
    number.rotation.y = Math.PI * -0.5;
    number.name = `floor-${floorNumber}`;

    const line = createLine(baseElementsPosition, positionLeftOfBuilding, color, positionNotBoldCorrection);
    const circle = createCircle(baseElementsPosition, positionLeftOfBuilding, size, number);

    floorElements.add(number);
    floorElements.add(line);
    floorElements.add(circle);
    if (!BmbyMode.active) {
        floorElements.visible = (floorNumberBool);
    }

    return floorElements;
}

function createCircle(baseElementsPosition, positionLeftOfBuilding, size, number) {
    const geometryCircle = new CircleGeometry(size, 30);
    const materialCircle = new MeshBasicMaterial({
        transparent: true,
        opacity: 0
    });
    const circle = new Mesh(geometryCircle, materialCircle);
    circle.position.set(number.position.x + 0.2, 0, (baseElementsPosition - size) * positionLeftOfBuilding);
    circle.rotation.y = Math.PI * -0.5;
    circle.position.y = size;
    circle.name = 'circle';
    circle.visible = false;

    return circle;
}

function createLine(baseElementsPosition, positionLeftOfBuilding, color, positionNotBoldCorrection) {
    const materialLine = new LineBasicMaterial({
        color,
        transparent: true,
        opacity: 0.3
    });
    const geometryLine = new BufferGeometry().setFromPoints([
        new Vector3(0, 0, 0),
        new Vector3(0, 0, (baseElementsPosition - positionNotBoldCorrection) * positionLeftOfBuilding)
    ]);
    const line = new Line(geometryLine, materialLine);
    line.geometry.attributes.position.needsUpdate = true;
    line.name = 'line';
    Boolean(config.features.buildingOpacity) && line.layers.enable(1);

    return line;
}

// export function rotateCylinderFloorNumbers() {
//     if (settingsData.activeViewMode !== ViewMode.Cylinder && settingsData.destroyedMode) {
//         return;
//     }
//
//     const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
//     if (!cylinderFloorNumbers) return;
//
//     cylinderFloorNumbers.children.forEach(item =>{
//         item.rotation.y = rotateToCamera();
//     });
// }

export function rotateCylinderFloorNumbers() {
    const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!cylinderFloorNumbers) return;

    cylinderFloorNumbers.children.forEach(item =>{
        item.rotation.y = rotateToCamera();
    });
}

export function removeCylinderFloorNumbers() {
    const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!cylinderFloorNumbers) return;
    threeJsVariables.scene.remove(cylinderFloorNumbers);
    cylinderFloorNumbers.traverse(e=>{
        if (e.isMesh || e.isLine){
            e.geometry.dispose();
            e.material.dispose();
        }
    })
}

let windowVector = new Vector2();
let canvasSize = new Vector2();

export function showOrHideCylinderFloorNumbers() {
    if (settingsData.activeViewMode !== ViewMode.Cylinder || BmbyMode.active)
        return;

    const floors = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
    if (!floors)
        return;

    const currentCameraDistance = getCurrentCameraDistance();
    const {minDistance,maxDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
    const {currentMinDistance,currentMaxDistance} = getOrbitControlsDistanceAndAngle();
    const {activate,foreshortening} = config.threejs.orbitControls.autoZoomSettings;
    const size = config.threejs.floorNumbers.size;
    const resizeCoefficient = config.threejs.floorNumbers.resizeCoefficient ? config.threejs.floorNumbers.resizeCoefficient : 2;
    const firstFloorNumber = Buildings.getActiveBuilding().floorSliderNumbers[Buildings.getActiveBuilding().floorSliderNumbers.length -1];
    const topFloorNumber = Buildings.getActiveBuilding().floorSliderNumbers[0];

    if (Math.ceil(currentMinDistance) !== Math.ceil(minDistance))
        return;

    let center = activate ? foreshortening : (maxDistance + minDistance) / 2;
    floors.traverse(el => {
       if (el.name === 'floorElements'){
           if (currentCameraDistance <= center){
               el.visible = true;
           } else if (currentCameraDistance > center){
               const currentFloor = parseInt(el.userData.floor, 10)
               const edgeFloor = currentFloor === firstFloorNumber || currentFloor === topFloorNumber;
               el.visible = (el.userData.floor % getMultiple() === 0) || edgeFloor;
           }
       } else if (isMobile && el.name.match(/floor/) ) {
           const line = el.parent.getObjectByName('line');
           if (!settingsData.isLandscape) {
               threeJsVariables.renderer.getSize(canvasSize);
               windowVector.set(window.innerWidth,window.innerHeight);

               if (canvasSize.equals(windowVector)) {
                   const cubSize = Math.abs(size * 3);
                   if (currentCameraDistance < cubSize) {
                       el.position.z = el.userData.defaultPosition.z + ((cubSize - currentCameraDistance) / (resizeCoefficient));
                       line.scale.z = 1 - ((cubSize - currentCameraDistance) / (resizeCoefficient * size));
                   } else {
                       el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
                       line.scale.z = 1;
                   }
               } else {
                   el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
                   line.scale.z = 1;
               }
           } else {
               el.position.set(el.userData.defaultPosition.x,el.userData.defaultPosition.y,el.userData.defaultPosition.z);
               line.scale.z = 1;
           }
       }
    });
}

// export const cylinderFloorNumbersResize = () => {
//     const windowWidth = window.innerWidth;
//     const cylinderFloorNumbers = threeJsVariables.scene.getObjectByName('cylinderFloorNumbers');
//
//     if (!cylinderFloorNumbers) return;
//
//     cylinderFloorNumbers.traverse(item => {
//         if (item.name === 'line') {
//             console.log(item);
//             let positions = item.geometry.attributes.position.array;
//
//             const newPositions = positions.map(point => {
//                 if (point !== 0) {
//                     point++;
//                 }
//                 return point;
//             });
//
//             // item.geometry.setAttribute('position', new THREE.BufferAttribute(newPositions, 2));
//             // item.geometry.computeBoundingBox();
//             // item.geometry.computeBoundingSphere();
//             // console.log(item);
//             // console.log(positions);
//             // console.log(newPositions);
//         }
//     });
// }

export function cylinderFloorNumbersIntersection(action) {
    if ((settingsData.activeViewMode !== ViewMode.Cylinder) && settingsData.destroyedMode)
        return;

    const {scene, raycaster} = threeJsVariables;
    const cylinderFloorNumbers = scene.getObjectByName('cylinderFloorNumbers');
    const intersects = (cylinderFloorNumbers)
        ? raycaster.intersectObjects(cylinderFloorNumbers.children, true)
        : [];

    const canvas = document.getElementById('c');

    if (intersects.length === 0) {
        // canvas.style.cursor = '';
        return;
    }

    const object = intersects[0].object;
    if (object.parent.name === 'floorElements' && object.parent.visible && object.name !== 'line') {
        canvas.style.cursor = 'pointer';

        if (action === 'click') {
            canvas.style.cursor = '';

            const currentFloor = object.parent.userData.floorIndex;
            const activeBuilding = Buildings.getActiveBuilding();
            const apartment = activeBuilding.apartments.find(apt => apt.userData.floor === currentFloor);

            settingsData.currentFloor = currentFloor;
            settingsData.lastClickedFlat = apartment;

            bombButtonInitActionHandler();
        }
    }
}

function getMultiple() {
    return config.threejs.floorNumbers?.multiple || (Buildings.getActiveBuilding().selectionsGroup.children.length < 10 ? 2 : 10);
}
